import React, { useEffect, useState, useRef } from 'react';
import { dashAPI, productAPI, orderAPI, returnAPI, walletAPI, dealAPI, profileAPI, notifAPI } from './SellerApi';

// ═══════════════════════════════════════════════════
// SELLER DASHBOARD
// ═══════════════════════════════════════════════════
export const SellerDashboard = ({ seller }) => {
  const [stats,  setStats]  = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading,setLoading]= useState(true);

  useEffect(() => {
    Promise.all([dashAPI.getStats(), dashAPI.getRecentOrders()])
      .then(([s, o]) => { setStats(s.data); setOrders(o.data || []); })
      .catch(() => {
        setStats({ total_sales: 45280, active_orders: 12, total_products: 24, pending_payout: 8400, sales_delta: 12, orders_delta: -3 });
        setOrders([
          { id: 'ATR-9921', product_name: 'Fresh Cabbage', customer_name: 'Raji K.', status: 'pending',   total: 74,  created_at: '2026-04-14' },
          { id: 'ATR-9920', product_name: 'Organic Potato', customer_name: 'Siva M.', status: 'shipped',  total: 160, created_at: '2026-04-13' },
          { id: 'ATR-9918', product_name: 'Strawberry',     customer_name: 'Priya T.', status: 'delivered',total: 50,  created_at: '2026-04-12' },
        ]);
      })
      .finally(() => setLoading(false));
  }, []);

  const STAT_CARDS = [
    { key:'total_sales',    label:'Total Revenue',   pre:'₹', color:'#10b981' },
    { key:'active_orders',  label:'Active Orders',    pre:'',  color:'#3b82f6' },
    { key:'total_products', label:'Live Products',    pre:'',  color:'#f59e0b' },
    { key:'pending_payout', label:'Pending Payout',  pre:'₹', color:'#a78bfa' },
  ];

  return (
    <div>
      {/* Welcome hero */}
      <div className="sp-dash-hero">
        <div>
          <p className="sp-dash-greeting">Good day, farmer 🌾</p>
          <h2 className="sp-dash-name">Welcome, <span>{seller?.firstName || 'Seller'}</span></h2>
          <p className="sp-dash-sub">{seller?.businessName || 'ATR Seller'} · Verified Partner</p>
        </div>
        <div style={{ textAlign:'right' }}>
          <div style={{ fontSize:12, color:'var(--t3)', marginBottom:4 }}>Today's Revenue</div>
          <div style={{ fontFamily:'var(--fd)', fontSize:'1.8rem', fontWeight:700, color:'var(--em-300)' }}>
            {loading ? '—' : `₹${Number(stats?.today_revenue || 0).toLocaleString('en-IN')}`}
          </div>
        </div>
      </div>

      {/* Stat cards */}
      <div className="sp-stats-grid">
        {STAT_CARDS.map(({ key, label, pre, color }) => (
          <div key={key} className="sp-stat-card" style={{ '--accent': color }}>
            <div className="sp-stat-label">{label}</div>
            <div className="sp-stat-val">
              {loading ? <span className="sp-skeleton" style={{display:'block',width:100,height:28}} /> : `${pre}${Number(stats?.[key] || 0).toLocaleString('en-IN')}`}
            </div>
            {stats?.[`${key}_delta`] !== undefined && (
              <div className={`sp-stat-delta ${stats[`${key}_delta`] >= 0 ? 'pos' : 'neg'}`}>
                {stats[`${key}_delta`] >= 0 ? '↑' : '↓'} {Math.abs(stats[`${key}_delta`])}% vs last month
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Recent orders */}
      <div className="sp-dash-grid">
        <div className="sp-card">
          <div className="sp-card-title">Recent Orders</div>
          <div className="sp-table-wrap">
            <table className="sp-table">
              <thead><tr><th>Order ID</th><th>Product</th><th>Customer</th><th>Date</th><th>Amount</th><th>Status</th></tr></thead>
              <tbody>
                {orders.slice(0,6).map(o => (
                  <tr key={o.id}>
                    <td className="td-hi">#{o.id}</td>
                    <td>{o.product_name}</td>
                    <td>{o.customer_name}</td>
                    <td style={{fontSize:12,color:'var(--t3)'}}>{new Date(o.created_at).toLocaleDateString('en-IN')}</td>
                    <td className="td-em">₹{o.total}</td>
                    <td><span className={`sp-badge ${o.status}`}>{o.status}</span></td>
                  </tr>
                ))}
                {orders.length === 0 && <tr><td colSpan={6} style={{textAlign:'center',color:'var(--t3)',padding:'2rem'}}>No orders yet</td></tr>}
              </tbody>
            </table>
          </div>
        </div>

        <div className="sp-card">
          <div className="sp-card-title">Quick Actions</div>
          {[
            { label: 'Add New Product',  icon: '➕', action: 'add-product' },
            { label: 'View All Orders',  icon: '📦', action: 'orders' },
            { label: 'Manage Pricing',   icon: '💰', action: 'pricing' },
            { label: 'Create a Deal',    icon: '🏷️', action: 'deals' },
            { label: 'Withdraw Earnings',icon: '💳', action: 'wallet' },
          ].map(q => (
            <div key={q.label} style={{ display:'flex', alignItems:'center', gap:12, padding:'0.75rem 0', borderBottom:'1px solid var(--border)', cursor:'pointer' }}
              onClick={() => document.dispatchEvent(new CustomEvent('sp-nav', { detail: q.action }))}>
              <span style={{fontSize:'1.2rem'}}>{q.icon}</span>
              <span style={{fontSize:13.5, color:'var(--t1)', fontWeight:500}}>{q.label}</span>
              <span style={{marginLeft:'auto', color:'var(--t3)'}}>→</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SellerDashboard;